import api from './client';
import type { ReleaseNote, ReleaseNoteFormData } from '../types';

// ---- Güncelleme Notları ----

/**
 * Yayınlanmış notlar, en yeni üstte (max 50). Tüm girişli kullanıcılar.
 * includeDrafts=true iken admin/yönetici taslakları da görür (diğer roller için
 * backend parametreyi yok sayar).
 */
export async function fetchReleaseNotes(includeDrafts = false): Promise<ReleaseNote[]> {
  const response = await api.get('/api/v1/release-notes', {
    params: includeDrafts ? { include_drafts: 1 } : undefined,
  });
  return response.data.data;
}

export async function createReleaseNote(data: ReleaseNoteFormData): Promise<ReleaseNote> {
  const response = await api.post('/api/v1/release-notes', data);
  return response.data.data;
}

export async function updateReleaseNote(
  noteId: number,
  data: ReleaseNoteFormData,
): Promise<ReleaseNote> {
  const response = await api.put(`/api/v1/release-notes/${noteId}`, data);
  return response.data.data;
}

export async function deleteReleaseNote(noteId: number): Promise<void> {
  await api.delete(`/api/v1/release-notes/${noteId}`);
}

/** Taslağı yayına alır; tüm kullanıcılara görünür olur (bildirim GÖNDERMEZ). */
export async function publishReleaseNote(noteId: number): Promise<ReleaseNote> {
  const response = await api.post(`/api/v1/release-notes/${noteId}/publish`);
  return response.data.data;
}

/** Yayınlanmış not için tüm kullanıcılara db + mail + push bildirimi gönderir (tek sefer). */
export async function notifyReleaseNote(noteId: number): Promise<ReleaseNote> {
  const response = await api.post(`/api/v1/release-notes/${noteId}/notify`);
  return response.data.data;
}

/** Nota oy ver (upsert kendi oyun). `comment` ile down oyu özellik isteğine dönüşebilir. */
export async function voteReleaseNote(
  noteId: number,
  vote: 'up' | 'down',
  comment?: string,
): Promise<ReleaseNote> {
  const response = await api.post(`/api/v1/release-notes/${noteId}/feedback`, {
    vote,
    ...(comment ? { comment } : {}),
  });
  return response.data.data;
}

/** Kendi oyunu geri al. */
export async function unvoteReleaseNote(noteId: number): Promise<void> {
  await api.delete(`/api/v1/release-notes/${noteId}/feedback`);
}
